export default __webpack_public_path__ + "static/media/gamepad.f34c2a4b.svg";